// Aba "Catálogo de serviços/produtos" de ComercialPropostas.
// Inclui CatalogoServicos (componente principal), ModalGerenciarAreas e FormServico.
// Extraído de ComercialPropostas.tsx durante refactor topológico.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';
import IconLixeira from '../../components/IconLixeira';
import { getToken } from './utils';
import {
  th, td, btnAcao, btnSec, btnPri, modalOverlay, modalContent,
  labelStyle, inputStyle,
} from './styles';

// ─────────────────────────── CATÁLOGO DE SERVIÇOS ───────────────────────────
export function CatalogoServicos() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [editando, setEditando] = useState<any | null>(null);
  const [novo, setNovo] = useState(false);
  const [filtroArea, setFiltroArea] = useState('todas');
  const [busca, setBusca] = useState('');
  const [modalAreas, setModalAreas] = useState(false);
  const [regenerando, setRegenerando] = useState(false);

  async function regenerarCodigos() {
    if (!window.confirm('Regerar TODOS os códigos baseando-se na área? Códigos antigos serão substituídos.')) return;
    setRegenerando(true);
    try {
      const token = await getToken();
      const r = await axios.post(`${API_URL}/comercial/servicos-produtos/regenerar-codigos`, {},
        { headers: { Authorization: token } });
      const data = r.data.body ? JSON.parse(r.data.body) : r.data;
      alert(`✓ ${data.atualizados} código(s) regerado(s).\nÁreas: ${(data.areas || []).join(', ')}`);
      await carregar();
    } catch (e: any) {
      alert('Erro: ' + (e.response?.data?.error || e.message));
    } finally { setRegenerando(false); }
  }

  useEffect(() => { carregar(); }, []);
  async function carregar() {
    setLoading(true);
    try {
      const token = await getToken();
      const res = await axios.get(`${API_URL}/comercial/servicos-produtos`, { headers: { Authorization: token } });
      const data = res.data.body ? JSON.parse(res.data.body) : res.data;
      setItems(data);
    } finally { setLoading(false); }
  }
  async function excluir(id: string) {
    if (!window.confirm('Desativar este serviço/produto?')) return;
    try {
      const token = await getToken();
      await axios.delete(`${API_URL}/comercial/servicos-produtos/${id}`, { headers: { Authorization: token } });
      await carregar();
    } catch (e: any) { alert('Erro: ' + e.message); }
  }
  const areas = Array.from(new Set(items.map(i => i.area).filter(Boolean))).sort();
  const filtrados = items.filter(i => {
    if (filtroArea !== 'todas' && i.area !== filtroArea) return false;
    if (!busca) return true;
    const q = busca.toLowerCase();
    return i.nome.toLowerCase().includes(q) || (i.codigo || '').toLowerCase().includes(q) || (i.descricao || '').toLowerCase().includes(q);
  });

  if (loading) return <div style={{ padding: 30, textAlign: 'center', color: '#888' }}>Carregando...</div>;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
        <h2 style={{ fontSize: 16, fontWeight: 500, margin: 0 }}>Catálogo de serviços/produtos</h2>
        <select value={filtroArea} onChange={e => setFiltroArea(e.target.value)}
          style={{ fontSize: 12, padding: '5px 10px', borderRadius: 5, border: '0.5px solid #ddd' }}>
          <option value="todas">Todas as áreas</option>
          {areas.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <input placeholder="Buscar..." value={busca} onChange={e => setBusca(e.target.value)}
          style={{ flex: 1, maxWidth: 280, padding: '5px 10px', fontSize: 12, borderRadius: 5, border: '0.5px solid #ddd' }} />
        <span style={{ fontSize: 11, color: '#888' }}>{filtrados.length}/{items.length}</span>
        <button onClick={() => setModalAreas(true)} title="Renomear / mesclar áreas"
          style={{ padding: '6px 12px', fontSize: 12, borderRadius: 5, background: '#fff', color: '#7C3AED', border: '0.5px solid #7C3AED', cursor: 'pointer', marginLeft: 'auto' }}>
          🗂️ Áreas
        </button>
        <button onClick={regenerarCodigos} disabled={regenerando} title="Reatribui códigos sequenciais por área (TOP-001, HID-001, ...)"
          style={{ padding: '6px 12px', fontSize: 12, borderRadius: 5, background: '#fff', color: '#0a7f4a', border: '0.5px solid #0a7f4a', cursor: regenerando ? 'not-allowed' : 'pointer', opacity: regenerando ? 0.5 : 1 }}>
          {regenerando ? '…' : '↻ Regerar códigos'}
        </button>
        <button onClick={() => setNovo(true)}
          style={{ padding: '6px 16px', fontSize: 12, borderRadius: 5, background: '#0930D0', color: '#fff', border: 'none', cursor: 'pointer' }}>
          + Novo serviço
        </button>
      </div>

      {modalAreas && (
        <ModalGerenciarAreas onClose={() => setModalAreas(false)} onAlterado={async () => { await carregar(); }} />
      )}

      <div style={{ border: '0.5px solid #e0e0e0', borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: '#020D7F', color: '#fff' }}>
              <th style={th}>Código</th>
              <th style={th}>Nome</th>
              <th style={th}>Área</th>
              <th style={{ ...th, width: 80 }}>Unidade</th>
              <th style={th}>Descrição</th>
              <th style={{ ...th, textAlign: 'center', width: 100 }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {filtrados.map((s, i) => (
              <tr key={s.id} style={{ borderBottom: '0.5px solid #f0f0f0', background: i % 2 === 0 ? '#fff' : '#FAFBFF' }}>
                <td style={{ ...td, fontFamily: 'monospace', color: '#6A7092', fontSize: 11 }}>{s.codigo || '—'}</td>
                <td style={{ ...td, fontWeight: 500, color: '#020D7F' }}>{s.nome}</td>
                <td style={td}>{s.area || '—'}</td>
                <td style={td}>{s.unidade || 'vb'}</td>
                <td style={{ ...td, color: '#666', fontSize: 11 }}>
                  {s.descricao ? (s.descricao.length > 80 ? s.descricao.slice(0, 80) + '…' : s.descricao) : '—'}
                </td>
                <td style={{ ...td, textAlign: 'center', whiteSpace: 'nowrap' }}>
                  <button onClick={() => setEditando(s)} style={btnAcao('#0930D0')}>Editar</button>
                  <button onClick={() => excluir(s.id)} style={btnAcao('#B91626')}><IconLixeira /></button>
                </td>
              </tr>
            ))}
            {filtrados.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 30, textAlign: 'center', color: '#aaa' }}>
                Nenhum serviço encontrado.
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {(editando || novo) && (
        <FormServico servico={editando}
          onClose={() => { setEditando(null); setNovo(false); }}
          onSaved={async () => { await carregar(); setEditando(null); setNovo(false); }} />
      )}
    </div>
  );
}

// ─────────────────────────── MODAL GERENCIAR ÁREAS ───────────────────────────
function ModalGerenciarAreas({ onClose, onAlterado }: {
  onClose: () => void;
  onAlterado: () => void;
}) {
  const [areas, setAreas] = useState<{ nome: string; n_servicos: number }[]>([]);
  const [loading, setLoading] = useState(true);
  const [editandoArea, setEditandoArea] = useState<string | null>(null);
  const [novoNome, setNovoNome] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => { carregar(); }, []);
  async function carregar() {
    setLoading(true);
    try {
      const token = await getToken();
      const r = await axios.get(`${API_URL}/comercial/areas`, { headers: { Authorization: token } });
      const data = r.data.body ? JSON.parse(r.data.body) : r.data;
      setAreas(Array.isArray(data) ? data : []);
    } finally { setLoading(false); }
  }
  async function renomear(de: string) {
    const para = (novoNome || '').trim();
    if (!para) { alert('Informe o novo nome.'); return; }
    if (de === para) { setEditandoArea(null); setNovoNome(''); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      const r = await axios.post(`${API_URL}/comercial/areas/renomear`,
        { de, para }, { headers: { Authorization: token } });
      const data = r.data.body ? JSON.parse(r.data.body) : r.data;
      const acao = areas.find(a => a.nome === para) ? 'mescladas em' : 'renomeada para';
      alert(`✓ ${data.servicos_afetados} serviço(s) ${acao} "${para}"`);
      setEditandoArea(null);
      setNovoNome('');
      await carregar();
      onAlterado();
    } catch (e: any) {
      alert('Erro: ' + (e.response?.data?.error || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <div style={modalOverlay} onClick={onClose}>
      <div style={{ ...modalContent, maxWidth: 560 }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 14px', fontSize: 14, color: '#020D7F' }}>🗂️ Gerenciar áreas</h3>
        <div style={{ fontSize: 11, color: '#666', marginBottom: 14, padding: 10, background: '#FAFBFF', borderRadius: 5, border: '0.5px solid #CDD4EA' }}>
          Renomear uma área move todos os serviços associados. Se digitar o nome de outra área existente, eles são <strong>mesclados</strong>.
        </div>
        {loading ? <div style={{ padding: 20, textAlign: 'center', color: '#888' }}>Carregando...</div> :
         areas.length === 0 ? <div style={{ padding: 20, textAlign: 'center', color: '#aaa' }}>Sem áreas em uso.</div> : (
          <table style={{ width: '100%', fontSize: 12, borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#F0F1F5' }}>
                <th style={{ padding: 8, textAlign: 'left', fontSize: 11 }}>Área</th>
                <th style={{ padding: 8, textAlign: 'right', width: 80, fontSize: 11 }}>Serviços</th>
                <th style={{ padding: 8, width: 100 }}></th>
              </tr>
            </thead>
            <tbody>
              {areas.map(a => (
                <tr key={a.nome} style={{ borderBottom: '0.5px solid #f0f0f0' }}>
                  <td style={{ padding: 8 }}>
                    {editandoArea === a.nome ? (
                      <input value={novoNome} onChange={e => setNovoNome(e.target.value)} autoFocus
                        onKeyDown={e => { if (e.key === 'Enter') renomear(a.nome); if (e.key === 'Escape') { setEditandoArea(null); setNovoNome(''); } }}
                        list="lista-areas"
                        style={{ width: '100%', padding: '4px 8px', fontSize: 12, borderRadius: 4, border: '1px solid #0930D0' }} />
                    ) : (
                      <strong style={{ color: '#020D7F' }}>{a.nome}</strong>
                    )}
                  </td>
                  <td style={{ padding: 8, textAlign: 'right', color: '#666' }}>{a.n_servicos}</td>
                  <td style={{ padding: 8, textAlign: 'right' }}>
                    {editandoArea === a.nome ? (
                      <>
                        <button onClick={() => renomear(a.nome)} disabled={salvando}
                          style={{ padding: '4px 10px', fontSize: 11, fontWeight: 600, borderRadius: 4, border: 'none', background: '#0930D0', color: '#fff', cursor: 'pointer' }}>
                          ✓
                        </button>
                        <button onClick={() => { setEditandoArea(null); setNovoNome(''); }}
                          style={{ padding: '4px 8px', fontSize: 11, borderRadius: 4, border: '0.5px solid #ddd', background: '#fff', cursor: 'pointer', marginLeft: 4 }}>
                          ×
                        </button>
                      </>
                    ) : (
                      <button onClick={() => { setEditandoArea(a.nome); setNovoNome(a.nome); }}
                        style={{ padding: '4px 10px', fontSize: 11, borderRadius: 4, border: '0.5px solid #0930D0', background: '#fff', color: '#0930D0', cursor: 'pointer' }}>
                        Renomear / mesclar
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
         )}
        <datalist id="lista-areas">
          {areas.map(a => <option key={a.nome} value={a.nome} />)}
        </datalist>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 14 }}>
          <button onClick={onClose}
            style={{ padding: '8px 18px', fontSize: 12, border: '0.5px solid #ddd', borderRadius: 5, background: '#fff', cursor: 'pointer' }}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

function FormServico({ servico, onClose, onSaved }: {
  servico: any | null; onClose: () => void; onSaved: () => void;
}) {
  const [form, setForm] = useState({
    codigo: servico?.codigo || '',
    nome: servico?.nome || '',
    area: servico?.area || '',
    unidade: servico?.unidade || 'vb',
    descricao: servico?.descricao || '',
  });
  const [salvando, setSalvando] = useState(false);
  async function salvar() {
    if (!form.nome.trim()) { alert('Nome obrigatório'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      if (servico) {
        await axios.put(`${API_URL}/comercial/servicos-produtos/${servico.id}`, form, { headers: { Authorization: token } });
      } else {
        await axios.post(`${API_URL}/comercial/servicos-produtos`, form, { headers: { Authorization: token } });
      }
      onSaved();
    } catch (e: any) { alert('Erro: ' + e.message); }
    finally { setSalvando(false); }
  }
  return (
    <div style={modalOverlay} onClick={onClose}>
      <div style={{ ...modalContent, maxWidth: 560 }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 14px', fontSize: 15, color: '#020D7F' }}>
          {servico ? 'Editar serviço' : 'Novo serviço/produto'}
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10, marginBottom: 10 }}>
          <div>
            <label style={labelStyle}>Código</label>
            <input value={form.codigo} onChange={e => setForm({ ...form, codigo: e.target.value })}
              placeholder="Ex.: TOP-PLA" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Nome *</label>
            <input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })}
              placeholder="Ex.: Levantamento planialtimétrico" style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Área</label>
            <input list="areas-sug" value={form.area} onChange={e => setForm({ ...form, area: e.target.value })}
              placeholder="Ex.: Topografia" style={inputStyle} />
            <datalist id="areas-sug">
              {['Topografia', 'Hidrologia', 'Hidrometria', 'Meio Ambiente', 'Projeto', 'Fiscalização', 'Consultoria', 'Documentação'].map(a =>
                <option key={a} value={a} />)}
            </datalist>
          </div>
          <div>
            <label style={labelStyle}>Unidade</label>
            <input list="unid-sug" value={form.unidade} onChange={e => setForm({ ...form, unidade: e.target.value })}
              style={inputStyle} />
            <datalist id="unid-sug">
              {['vb', 'un', 'h', 'dia', 'mês', 'km', 'ha', 'm', 'm²', 'm³', 'amostra', 'medição'].map(u =>
                <option key={u} value={u} />)}
            </datalist>
          </div>
        </div>
        <label style={labelStyle}>Descrição (aparece pré-preenchida na proposta ao selecionar este serviço)</label>
        <textarea value={form.descricao} onChange={e => setForm({ ...form, descricao: e.target.value })}
          style={{ ...inputStyle, minHeight: 80, resize: 'vertical', fontSize: 12 }} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14 }}>
          <button onClick={onClose} style={btnSec}>Cancelar</button>
          <button onClick={salvar} disabled={salvando} style={btnPri}>
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
}
